export default "https://cdn-static.gokick.com/assets/4e1d6b599b0c658e33aa5c1b8604da35a9a49f05/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";